import { buildUrl, handleResponse } from "./auth";

export const getAdminDashboard = () =>
  fetch(buildUrl("/api/admin/dashboard"), {
    credentials: "include",
  }).then(handleResponse);

export const getAdminOperationalSnapshot = ({ date } = {}) => {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  const suffix = params.toString() ? `?${params.toString()}` : "";

  return fetch(buildUrl(`/api/admin/dashboard/operational-snapshot${suffix}`), {
    credentials: "include",
  }).then(handleResponse);
};

const adminDashboardApi = { getAdminDashboard, getAdminOperationalSnapshot };

export default adminDashboardApi;
